import PropertyListView from '../view'
import HTML from '../../../../../html'
import events from '../../../../../event-emitter'

export default class PropertyFilterView extends PropertyListView {
    
    constructor(controller) {
        super(controller)
    }
    
    initObjektsPagination() {
        this.controller.objektsPagination.showOnScreen = this.controller.objektsPagination.perScreen
        this.controller.objektsPagination.moreButton =
            this.controller.filteredProps.objekts.length <= this.controller.objektsPagination.showOnScreen
            ? ''
            : HTML('a')
                .classes('load-more-button show-on-objekts')
                .attr({ href: '#' })
                .content('Ladda mer')
                .on('click', event => {
                    event.preventDefault()
                    this.controller.objektsPagination.showOnScreen
                        = this.controller.objektsPagination.showOnScreen
                        + this.controller.objektsPagination.perScreen
                    if (this.controller.objektsPagination.showOnScreen > this.controller.filteredProps.objekts.length) {
                        this.controller.objektsPagination.showOnScreen = this.controller.filteredProps.objekts.length
                        this.controller.objektsPagination.moreButton = ''
                    }
                    this.controller.updateProps()
                })
                .render()
    }
}
